export default __webpack_public_path__ + "static/media/main-logo-light.b6385a68.png";